import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import getTimeUnits from "./getTimeUnits";
dayjs.extend(duration);
const getTimeUnitsInHoursAndMinutes = (ms) => getTimeUnits({
  durationInMs: ms,
  unitsRequested: ["hours", "minutes"],
  asUnit: true,
  roundup: true
});
var getTimeUnitsInHoursAndMinutes_default = getTimeUnitsInHoursAndMinutes;
export {
  getTimeUnitsInHoursAndMinutes_default as default
};
